var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 4.9974V4.33073C13.8333 3.39731 13.8333 2.9306 13.6517 2.57408C13.4919 2.26047 13.2369 2.00551 12.9233 1.84572C12.5668 1.66406 12.1001 1.66406 11.1667 1.66406H9.83333C8.89991 1.66406 8.4332 1.66406 8.07668 1.84572C7.76308 2.00551 7.50811 2.26047 7.34832 2.57408C7.16667 2.9306 7.16667 3.39731 7.16667 4.33073V4.9974M8.83333 9.58073V13.7474M12.1667 9.58073V13.7474M3 4.9974H18M16.3333 4.9974V14.3307C16.3333 15.7309 16.3333 16.4309 16.0608 16.9657C15.8212 17.4361 15.4387 17.8186 14.9683 18.0582C14.4335 18.3307 13.7335 18.3307 12.3333 18.3307H8.66667C7.26654 18.3307 6.56647 18.3307 6.03169 18.0582C5.56129 17.8186 5.17883 17.4361 4.93915 16.9657C4.66667 16.4309 4.66667 15.7309 4.66667 14.3307V4.9974",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.a66191de7e13a003b851b97bf9cc99f5.svg";
export { ForwardRef as ReactComponent };